import { render, staticRenderFns } from "./disposePop.vue?vue&type=template&id=f6b1c9ac&scoped=true&"
import script from "./disposePop.vue?vue&type=script&lang=js&"
export * from "./disposePop.vue?vue&type=script&lang=js&"
import style0 from "./disposePop.vue?vue&type=style&index=0&id=f6b1c9ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b1c9ac",
  null
  
)

export default component.exports